import classNames from "classnames";
import { Paper, Typography, styled } from "@mui/material";

const ContentPanel = ({ title, className, children }) => (
  <Paper className={classNames("content-panel", className)}>
    {title && <Typography variant="h5">{title}</Typography>}
    {children}
  </Paper>
);

export default styled(ContentPanel)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  "> .MuiTypography-h5": {
    marginBottom: theme.spacing(3),
  },
}));
